import React from 'react';
import { css } from '@emotion/css';
import { IconS24AlertCircle24Filled } from '@is24/cosma-ui-icons';
import { RED500 } from '../../../domain/colors';

const styles = {
  errorMessage: css`
    display: flex;
    color: ${RED500};
    text-align: center;
    margin: 8px 0px;
    align-items: center;
  `,
  text: css`
    margin: 8px;
  `,
};

export const BenefitsErrorMessage = ({ text }: { text: string }) => {
  return (
    <div className={`${css(styles.errorMessage)}`}>
      <IconS24AlertCircle24Filled />

      <p className={`${css(styles.text)}`}>{text}</p>
    </div>
  );
};
